import { render, staticRenderFns } from "./InputTargetTypeForFamily.vue?vue&type=template&id=0c93cea6&lang=pug"
import script from "./InputTargetTypeForFamily.vue?vue&type=script&lang=ts"
export * from "./InputTargetTypeForFamily.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports